import React, { useState } from "react";

import Header from "../components/Header";
import FooterComponent from "../components/FooterComponent.js";
import { useLanguage } from "../contexts/LanguageContext";
import { useProducts } from "../contexts/ProductsContext";
import { cloudinaryUrl, PRODUCTS_FOLDER } from "../utils/cloudinary";
import CloudinaryImage from "../components/CloudinaryImage";

const Gallery = () => {
  const { language } = useLanguage();
  const { products, loading, error } = useProducts();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState("");

  const openModal = (imageSrc) => {
    setModalImage(imageSrc);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalImage("");
  };

  const galleryItems = (products ?? []).flatMap((p) =>
    (p.photos ?? []).map((filename) => ({
      filename,
      src: cloudinaryUrl(filename, PRODUCTS_FOLDER, 800),
      productId: p.id,
      name: p.name,
    })),
  );

  return (
    <div className="bg-cream min-h-screen">
      <Header />

      <div className="text-center py-20 px-6">
        <p className="text-xs tracking-[0.3em] uppercase text-gold mb-4 font-light">
          {language === "pt" ? "Inspiração" : "Inspiration"}
        </p>
        <h1 className="font-display text-5xl md:text-6xl text-stone-800 mb-4">
          {language === "pt" ? "A Nossa Galeria" : "Our Gallery"}
        </h1>
        <p className="text-stone-400 font-light max-w-md mx-auto text-sm leading-relaxed">
          {language === "pt"
            ? "Veja todas as nossas peças diferentes e muito mais."
            : "See all our different pieces and much more."}
        </p>
      </div>

      {/* Instagram callout */}
      <div className="max-w-xl mx-auto px-6 mb-12 text-center">
        <a
          href="https://www.instagram.com/tamtambygs/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 text-stone-500 hover:text-gold-dark transition-colors duration-200"
        >
          <img
            src={require("../assets/logo-insta.png")}
            alt={language === "pt" ? "Logo do Instagram" : "Instagram logo"}
            className="w-8 h-8 rounded"
          />
          <span className="text-xs tracking-widest uppercase">
            {language === "pt"
              ? "Siga-nos @tamtambygs"
              : "Follow us @tamtambygs"}
          </span>
        </a>
      </div>

      {/* Gallery grid */}
      {error ? (
        <div className="max-w-6xl mx-auto px-6 pb-20 text-center text-stone-400">
          {language === "pt"
            ? "Não foi possível carregar a galeria."
            : "Could not load the gallery."}
        </div>
      ) : loading ? (
        <div className="max-w-6xl mx-auto px-6 pb-20 text-center text-stone-400">
          {language === "pt" ? "A carregar…" : "Loading…"}
        </div>
      ) : (
        <div className="max-w-6xl mx-auto px-6 pb-20">
          <div className="columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4">
            {galleryItems.map((item, index) => (
              <div
                key={`${item.productId}-${item.filename}`}
                className="break-inside-avoid"
              >
                <CloudinaryImage
                  src={item.src}
                  imgClassName="w-full object-cover cursor-pointer hover:opacity-90 transition-opacity duration-300"
                  alt={
                    language === "pt"
                      ? `Imagem da Galeria ${index + 1}`
                      : `Gallery Image ${index + 1}`
                  }
                  onClick={() => openModal(item.src)}
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 z-50 bg-stone-950/90 flex items-center justify-center"
          onClick={closeModal}
        >
          <div className="relative p-4" onClick={(e) => e.stopPropagation()}>
            <CloudinaryImage
              src={modalImage}
              alt={language === "pt" ? "Vista ampliada" : "Enlarged view"}
              wrapperClassName="inline-block"
              imgClassName="max-w-[90vw] max-h-[90vh] object-contain"
              loading="eager"
            />
            <button
              onClick={closeModal}
              className="absolute top-6 right-6 w-9 h-9 bg-stone-800 hover:bg-stone-700 flex items-center justify-center transition-colors duration-200"
              aria-label={language === "pt" ? "Fechar" : "Close"}
            >
              <svg
                className="w-4 h-4 text-stone-300"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      )}

      <FooterComponent />
    </div>
  );
};

export default Gallery;